/**
 * Versión de la aplicación
 * 
 * Este archivo contiene la versión actual de la aplicación.
 * Actualiza este valor manualmente cuando realices un release.
 */
export const APP_VERSION = '1.2.0';



